export enum OrderTypes {
  Subscription = 1,
  Renewal = 2
}
